import { render, staticRenderFns } from "./defaultPaypalForm.vue?vue&type=template&id=b8ba363a"
import script from "./defaultPaypalForm.vue?vue&type=script&lang=js"
export * from "./defaultPaypalForm.vue?vue&type=script&lang=js"
import style0 from "./defaultPaypalForm.vue?vue&type=style&index=0&id=b8ba363a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports